import axios from "axios";

export const baseURL = axios.create({
    // baseURL: "http://localhost:3000/api/v1",
   baseURL: "https://dev.lahjakamu.com/api/v1"
  });